import { render, staticRenderFns } from "./appCardComponent.vue?vue&type=template&id=285e7bbc&"
import script from "./appCardComponent.vue?vue&type=script&lang=js&"
export * from "./appCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./appCardComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports